import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';
import { SwiperOptions } from 'swiper/types';
import { SignUpModalComponent } from '../../sign-up-modal/sign-up-modal.component';

@Component({
	selector: 'app-loyalty-slider',
	templateUrl: './loyalty-slider.component.html',
	styleUrls: ['./loyalty-slider.component.scss'],
})
export class LoyaltySliderComponent implements OnInit {
	@Output() signIn = new EventEmitter<void>();
	@Output() back = new EventEmitter<void>();
	public sliderData = [
		{
			title: this.translate.instant('loyalty_slider.first.title'),
			info: this.translate.instant('loyalty_slider.first.info'),
			image: this.translate.instant('loyalty_slider.first.image'),
		},
		{
			title: this.translate.instant('loyalty_slider.second.title'),
			info: this.translate.instant('loyalty_slider.second.info'),
			image: this.translate.instant('loyalty_slider.second.image'),
		},
		{
			title: this.translate.instant('loyalty_slider.third.title'),
			info: [
				this.translate.instant('loyalty_slider.third.sub-info.1'),
				this.translate.instant('loyalty_slider.third.sub-info.2'),
				this.translate.instant('loyalty_slider.third.sub-info.3'),
			],
			dopInfo: [
				this.translate.instant('loyalty_slider.third.sub-info.1_subtitle'),
				this.translate.instant('loyalty_slider.third.sub-info.2_subtitle'),
				this.translate.instant('loyalty_slider.third.sub-info.3_subtitle'),
			],
		},
		{
			title: this.translate.instant('loyalty_slider.fourth.title'),
			info: this.translate.instant('loyalty_slider.fourth.info'),
			image: this.translate.instant('loyalty_slider.fourth.image'),
		},
		{
			title: this.translate.instant('loyalty_slider.fifth.title'),
			info: this.translate.instant('loyalty_slider.fifth.info'),
			image: this.translate.instant('loyalty_slider.fifth.image'),
		},
	];
	public config: SwiperOptions = {
		slidesPerView: 1,
		speed: 10000,

		loop: true,
		allowTouchMove: true,
		slidesPerGroup: 2,

		freeMode: true,
		spaceBetween: 0,
		grabCursor: true,
	};
	public slideOpts = {
		initialSlide: 0,
		speed: 400,
		autoplay: true,
	};
	showSignUpButtons = true;
	constructor(private translate: TranslateService, private modalCtrl: ModalController) {}

	ngOnInit() {}
	static async show(modalCtrl: ModalController, showSignUpButtons: boolean = true): Promise<boolean> {
		const modal = await modalCtrl.create({
			component: LoyaltySliderComponent,
			cssClass: 'slider-modal',
			componentProps: {
				showSignUpButtons,
			},
		});
		await modal.present();
		const result = await modal.onDidDismiss();
		await sleep(100);
		return result.data;
	}
	cancel() {
		this.modalCtrl.dismiss();
		this.back.emit();
	}
	register() {
		this.modalCtrl.dismiss(true);
		this.signIn.emit();
	}
	signUp() {
		this.modalCtrl.dismiss();
		SignUpModalComponent.show(this.modalCtrl);
	}
}
